// extracted by mini-css-extract-plugin
export default {"block-item":"StatsPage_block-item__iLlBo","title":"StatsPage_title__iFRAE","description":"StatsPage_description__cc-4G","stats-page":"StatsPage_stats-page__E+nuh"};